module.exports = __webpack_public_path__ + "img/bg.67bf9a7d.svg";